import Vue from 'vue';
import { dialogBoxManager } from "./dialogs/manager";
import { postcodeInputData, postcodeInputDirectives, postcodeInputMethods } from "./postcode-input.mjs";
import { PostcodeSearchDialog } from "./dialogs/postcode-search.mjs";
import { LoginDialog } from "./dialogs/login-dialog.mjs";
import { mediaQueryState } from "./responsive.mjs";

export const navigationDefinition = {
    data : {
        // Postcode input for mobile is present in the header
        ...postcodeInputData,
        menuOpen      : false,
        myAccountOpen : false,
        collapsed     : false
    },
    directives : {
        ...postcodeInputDirectives
    },
    methods : {
        // Postcode input for mobile is present in the header
        ...postcodeInputMethods,

        // This method is designed to stop click events from bubbling up outside
        // of whatever element it's bound to. We want an open 'my account' menu
        // to close on any random body click events, so it's important we don't
        // let them escape from the menu itself or it won't stay open.
        stopPropagation: function( event ) {
            event.stopPropagation();
            return true;
        },
        toggleMenu: function( event ) {
            this.menuOpen = ! this.menuOpen;
        },
        toggleMyAccount: function() {
            this.myAccountOpen = ! this.myAccountOpen;
        },
        callLoginDialog : function( event ) {
            if( mediaQueryState.isMobile() )
                return true;

            event.preventDefault();
            dialogBoxManager.pushDialog( new LoginDialog() );
            return false;
        },
        callLogoutForm : function( event ) {
            event.preventDefault();
            const form = document.getElementById('logout-form');
            form && form.submit();
        },
        callPostcodeSearchDialog( postcode ) {
            dialogBoxManager.pushDialog( new PostcodeSearchDialog(postcode) );
        }
    },
    mounted : function() {
        // scroll listener?
    }
};

const elementId = 'navigation-frame';
const element   = document.getElementById(elementId);

if( element ) {
    const nav = new Vue({ ...navigationDefinition, el: `#${elementId}` });
    // clicks bubbling up to Body should close the my account menu.
    // We already suppress propagation in the my account menu.
    // This function must return true, or all click events become void.
    document.getElementsByTagName('body')[0].onclick = () => {
        nav.myAccountOpen = false;
        // ...again, this _must_ return true, or the entire page stops working...
        return true;
    };
}
